import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Heart } from 'lucide-react';
import ReactionChips from './ReactionChips';

const AIResponseCard = ({ result }) => (
  <Card className="card-surface border-[#27272A] mb-6" data-testid="ai-response-card">
    <CardHeader>
      <CardTitle className="flex items-center gap-2" style={{ fontFamily: 'Outfit' }}>
        <Heart className="w-5 h-5 text-[#8B5CF6]" />
        {result.response_style === 'Adaptive' ? 'Adaptive' : result.response_style}
      </CardTitle>
    </CardHeader>
    <CardContent className="space-y-6">
      <div className="prose prose-invert max-w-none">
        <p className="text-base leading-relaxed text-[#F9FAFB]" data-testid="ai-response-text">{result.ai_response}</p>
      </div>
      {result.detected_tones?.length > 0 && (
        <div>
          <h3 className="text-sm uppercase tracking-[0.2em] font-bold text-[#A1A1AA] mb-3">Detected Emotional Tones</h3>
          <div className="flex flex-wrap gap-2" data-testid="detected-tones">
            {result.detected_tones.map((tone) => (
              <span key={`tone-${tone.toLowerCase()}`} className="tone-badge" data-testid={`tone-${tone.toLowerCase()}`}>{tone}</span>
            ))}
          </div>
        </div>
      )}
      {result.message_id && (
        <ReactionChips messageId={result.message_id} initialReaction={result.user_reaction} />
      )}
    </CardContent>
  </Card>
);

export default AIResponseCard;
